import React from 'react';
import '../forms/Button.css';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { downloadFile } from '../../actions/helper';
import PDFDownload from '../../images/download.png';

class ExportInstallationDocumentPdf extends React.Component {
  download = () => {
    const { installationDocumentId } = this.props;
    if (installationDocumentId !== undefined) {
      downloadFile(installationDocumentId, '/installationdocument/report/pdf');
    }
  };

  render() {
    return (
      <img src={PDFDownload} alt="pdf-download" onClick={this.download} width="30px" />
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);

  return {
    currentLanguage: activeLanguage?.code || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(ExportInstallationDocumentPdf);
